import { render, staticRenderFns } from "./SchoolclassesCalendar.vue?vue&type=template&id=5b3e4c1e"
import script from "./SchoolclassesCalendar.vue?vue&type=script&lang=js"
export * from "./SchoolclassesCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports